import type { Optional } from '@festina-life/core'
import { createRequiredAndOptionalContext } from '@festina-life/ui/libs'

export type EventSelection = {
  type: 'event' | 'unappliedCommand'
  id: string
}

export type EventSelectionWithApplyDate = EventSelection & {
  applyDate: string
}

type CommitmentEventSelectionContext = {
  current: Optional<EventSelectionWithApplyDate>
  previous: Optional<EventSelectionWithApplyDate>
  setCurrent: (event: Optional<EventSelectionWithApplyDate>) => void
  setPrevious: (event: Optional<EventSelectionWithApplyDate>) => void
}

const [
  useCommitmentEventSelectionContext,
  useOptionalCommitmentEventSelectionContext,
  Provider,
] = createRequiredAndOptionalContext<CommitmentEventSelectionContext>(
  'CommitmentEventSelectionContext',
)

export {
  Provider,
  useCommitmentEventSelectionContext,
  useOptionalCommitmentEventSelectionContext,
}
